module.exports = {
	'customFolder.m3.m310320': {
		'userSettings': '設定工作時間',
		'scheduleGroupName': '群組',
		'unpin': '取消釘選',
		'nailDown': '釘選',
	},
	'customFolder.m3.m310320_grid': {
		'shiftType': '班別類型',
		'thereAreClassesLeft': '還有<%=temp1%>個班別',
		'shiftInformationLabel': '班別資訊/標籤',
		'joinTheWorkforce': '加入人力',
		'editStaff': '編輯人力',
		'duplicateWorkingHoursTimePeriod': '工作時間重疊',
		'time': '時',
		'breakTime': '休息時間',
	},
};
